/** Baseline Requirements dashboard card icon. */
export function BaselineRequirementsIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M2.64645 4.35353L1.64645 3.35353L2.35356 2.64642L3.00001 3.29287L4.64645 1.64642L5.35356 2.35353L3.35356 4.35353C3.1583 4.54879 2.84172 4.54879 2.64645 4.35353Z"
        fill="currentColor"
      />
      <path
        d="M1.64645 8.35353L2.64645 9.35353C2.84172 9.54879 3.1583 9.54879 3.35356 9.35353L5.35356 7.35353L4.64645 6.64642L3.00001 8.29287L2.35356 7.64642L1.64645 8.35353Z"
        fill="currentColor"
      />
      <path d="M4.00001 12H2.00001V13H4.00001V12Z" fill="currentColor" />
      <path d="M6.00001 13H14V12H6.00001V13Z" fill="currentColor" />
      <path d="M14 4H6.00001V3H14V4Z" fill="currentColor" />
      <path d="M6.00001 8.5H14V7.5H6.00001V8.5Z" fill="currentColor" />
    </svg>
  );
}
